// extracted by mini-css-extract-plugin
export var root = "vwdp";
export var rootIcon = "yGdR";
export var rootIcons = "_7zq7";
export var rootIconsPayment = "-wNl";
export var rootIconsShipping = "mEmf";
export var rootMeta = "_8g3h";
export var rootMetaLinks = "l1li";